import { REQUEST, PAYMENT_OVERVIEW_FETCH, PAYMENT_OVERVIEW_SET } from '@/constants';

/**
 * @typedef {object} Voucher
 * @prop {number} id
 * @prop {number} client_id
 */

export default {
    state: {
        paymentOverview: {},
    },
    getters: {},
    mutations: {
        [PAYMENT_OVERVIEW_SET](state, paymentOverview) {
            state.paymentOverview = paymentOverview;
        },
    },
    actions: {
        async [PAYMENT_OVERVIEW_FETCH]({ commit, dispatch }) {
            commit(PAYMENT_OVERVIEW_SET, {});
            const responsePaymentOverview = await dispatch(REQUEST, {
                url: 'vouchers/payment-overview',
            });

            if (responsePaymentOverview.status !== 200) return responsePaymentOverview;

            const allVouchers = responsePaymentOverview.data.data;

            const paymentOverviews = {};
            for (const [clientId, vouchers] of sortByClientId(allVouchers).entries()) {
                paymentOverviews[clientId] = makePaymentOverview(vouchers);
            }

            commit(PAYMENT_OVERVIEW_SET, paymentOverviews);
        },
    },
};

const sortByClientId = (vouchers) => {
    /** @type {Map<number, Voucher>} */
    const voucherByClientId = new Map();
    for (const voucher of vouchers) {
        if (!voucherByClientId.has(voucher.client_id)) {
            voucherByClientId.set(voucher.client_id, []);
        }
        voucherByClientId.get(voucher.client_id).push(voucher);
    }
    return voucherByClientId;
};

const makePaymentOverview = (vouchers) => {
    const voucherBatches = new Map();

    for (const voucher of vouchers) {
        if (voucher.is_credit) continue;

        const voucherKey = `${voucher.created_at}_${voucher.duration}`;
        const batch = voucherBatches.get(voucherKey);

        if (batch) {
            batch.ids.push(voucher.id);
            batch.count++;

            if (batch.paid ^ voucher.paid) {
                console.warn({
                    message: 'Only a part of the vouchers in a batch are paid',
                    voucher,
                    batch,
                });
                batch.paid &&= voucher.paid;
            }
        } else {
            voucherBatches.set(voucherKey, {
                ids: [voucher.id],
                count: 1,
                paid: voucher.paid,
                duration: voucher.duration,
                createdAt: voucher.created_at,
                type: voucher.type,
            });
        }
    }
    return voucherBatches;
};
